import { c as _c } from "react/compiler-runtime";
import { Text, clx } from "@medusajs/ui";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import React from "react";
type AccordionItemProps = AccordionPrimitive.AccordionItemProps & {
  title: string;
  subtitle?: string;
  description?: string;
  required?: boolean;
  tooltip?: string;
  forceMountContent?: true;
  headingSize?: "small" | "medium" | "large";
  customTrigger?: React.ReactNode;
  complete?: boolean;
  active?: boolean;
  triggerable?: boolean;
  children: React.ReactNode;
  icon?: React.ReactNode;
};
type AccordionProps = (AccordionPrimitive.AccordionSingleProps & React.RefAttributes<HTMLDivElement>) | (AccordionPrimitive.AccordionMultipleProps & React.RefAttributes<HTMLDivElement>);
const Accordion: React.FC<AccordionProps> & {
  Item: React.FC<AccordionItemProps>;
} = t0 => {
  const $ = _c(6);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props) {
    t1 = <AccordionPrimitive.Root {...props}>{children}</AccordionPrimitive.Root>;
    $[3] = children;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
const Item: React.FC<AccordionItemProps> = t0 => {
  const $ = _c(48);
  let children;
  let className;
  let description;
  let icon;
  let props;
  let subtitle;
  let t1;
  let t2;
  let t3;
  let title;
  if ($[0] !== t0) {
    const {
      title: t4,
      subtitle: t5,
      description: t6,
      children: t7,
      className: t8,
      headingSize: t9,
      customTrigger: t10,
      forceMountContent: t11,
      triggerable,
      icon: t12,
      ...t13
    } = t0;
    title = t4;
    subtitle = t5;
    description = t6;
    children = t7;
    className = t8;
    t1 = t9;
    t2 = t10;
    t3 = t11;
    icon = t12;
    props = t13;
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = description;
    $[4] = icon;
    $[5] = props;
    $[6] = subtitle;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = title;
  } else {
    children = $[1];
    className = $[2];
    description = $[3];
    icon = $[4];
    props = $[5];
    subtitle = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    title = $[10];
  }
  t1 === undefined ? "large" : t1;
  const customTrigger = t2 === undefined ? undefined : t2;
  const forceMountContent = t3 === undefined ? undefined : t3;
  let t4;
  if ($[11] !== className) {
    t4 = clx("last:mb-0", "py-3", className);
    $[11] = className;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== icon) {
    t5 = icon && <div className="self-center">{icon}</div>;
    $[13] = icon;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== title) {
    t6 = <Text className="text-black text-sm font-lealti-light ">{title}</Text>;
    $[15] = title;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <div className="flex items-center gap-4 text-black">{t5}{t6}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== customTrigger) {
    t8 = customTrigger || <MorphingTrigger />;
    $[20] = customTrigger;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t8) {
    t9 = <AccordionPrimitive.Trigger>{t8}</AccordionPrimitive.Trigger>;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t7 || $[25] !== t9) {
    t10 = <div className="flex w-full items-center justify-between">{t7}{t9}</div>;
    $[24] = t7;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== subtitle) {
    t11 = subtitle && <Text as="span" size="small" className="mt-1 text-black">{subtitle}</Text>;
    $[27] = subtitle;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t10 || $[30] !== t11) {
    t12 = <AccordionPrimitive.Header className="px-1"><div className="flex flex-col">{t10}{t11}</div></AccordionPrimitive.Header>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = clx("radix-state-closed:animate-accordion-close radix-state-open:animate-accordion-open radix-state-closed:pointer-events-none px-1");
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== description) {
    t14 = description && <Text>{description}</Text>;
    $[33] = description;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== children) {
    t15 = <div className="w-full">{children}</div>;
    $[35] = children;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t14 || $[38] !== t15) {
    t16 = <div className="inter-base-regular group-radix-state-closed:animate-accordion-close">{t14}{t15}</div>;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== forceMountContent || $[41] !== t16) {
    t17 = <AccordionPrimitive.Content forceMount={forceMountContent} className={t13}>{t16}</AccordionPrimitive.Content>;
    $[40] = forceMountContent;
    $[41] = t16;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== props || $[44] !== t12 || $[45] !== t17 || $[46] !== t4) {
    t18 = <AccordionPrimitive.Item {...props} className={t4}>{t12}{t17}</AccordionPrimitive.Item>;
    $[43] = props;
    $[44] = t12;
    $[45] = t17;
    $[46] = t4;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  return t18;
};
Accordion.Item = Item;
const MorphingTrigger = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="text-black hover:bg-grey-5 active:bg-grey-5 active:text-violet-60 focus:border-violet-60 disabled:text-grey-30 bg-transparent disabled:bg-transparent rounded-rounded group relative p-[6px]"><div className="h-5 w-5"><span className="bg-black rounded-circle group-radix-state-open:rotate-90 absolute inset-y-[31.75%] left-[48%] right-1/2 w-[1.5px] duration-300" /><span className="bg-black rounded-circle group-radix-state-open:rotate-90 group-radix-state-open:left-1/2 group-radix-state-open:right-1/2 absolute inset-x-[31.75%] top-[48%] bottom-1/2 h-[1.5px] duration-300" /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Accordion;